import { OpenAI } from "openai";

const openai = new OpenAI({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY,
    dangerouslyAllowBrowser: true
});


const createSummary = async (input) => {
    try {
        const summary = await openai.chat.completions.create({
            messages: [{
                role: 'user',
                content: `Write a summary for ${input}. This is a new groundbreaking idea so make sure that it is very colorful and exciting! You may use a maximum of 500 characters. `
            }],
            model: 'gpt-3.5-turbo',
        })
        const text = summary.choices[0].message.content;
        return text;

    } catch (err) {
        console.error(err);
    }
};

export default createSummary;